<template>
    <div>

      <CoursesListFilters />

      <BCard no-body class="mb-0">
        <!-- Filtros -->
        <div class="m-2">
          <BRow>
            <BCol cols="12" md="4" lg="5" xl="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>{{ $t('Show') }}</label>
              <vSelect v-model="perPage" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
              <label>{{$t('entries')}}</label>
            </BCol>
            <BCol cols="12" md="8" lg="7" xl="6">
              <div class="d-flex align-items-center justify-content-between">
                <TextInputValidated :vsModel.sync="searchQuery" :vsCols="false" vsPlaceholder="Buscar ..." class="d-inline-block mr-1" />
                <BButton  :variant="isTrashedTableActive ? 'danger' : 'outline-danger'" class="mr-1" @click="changeTable()" v-if="ability.can('delete', 'coursekk')">
                  <FeatherIcon icon="TrashIcon" />
                </BButton>
                <BDropdown id="dropdown-3" text="Exportar" variant="success" class="mr-1">
                  <BDropdownItem @click="download('PDF')">PDF</BDropdownItem>
                  <BDropdownItem @click="download('CSV')">CSV</BDropdownItem>
                  <BDropdownItem @click="download('XLS')">XLS</BDropdownItem>
                  <BDropdownItem @click="openDateModal(null, 'signatures', null)">Firmas cursos activos</BDropdownItem>
                </BDropdown>
                <BButton variant="primary" :to="{ name: 'courses-add' }" v-if="ability.can('create', 'course')">
                  <span class="text-nowrap">{{$t('Add course')}}</span>
                </BButton>
              </div>
            </BCol>
          </BRow>
        </div>

        <!-- Tabla de cursos borrados -->
        <BTable ref="trashedCourseTable" :items="trashedCourses" :fields="trashedCoursesColumns" v-if="isTrashedTableActive" responsive show-empty empty-text="No hay alumnos en la papelera">

          <template #cell(course)="data">
            <span><b>{{ data.item.name }}</b></span><br>
            <span class="text-muted"><small>{{ data.item.code }} | {{ data.item.section ? data.item.section.name : ''}}</small></span>
          </template>

          <!-- Columna: Acciones -->
          <template #cell(actions)="data">
            <BButton variant="primary" class="mr-1" @click="restoreCoursefn(data.item.id)">
              <FeatherIcon icon="RewindIcon" class="mr-1" />
              <span>Restaurar</span>
            </BButton>
            <!-- <BButton variant="danger">
              <FeatherIcon icon="Trash2Icon" class="mr-1" @click="detroyCourse(data.item.id)" />
              <span>Eliminar completamente</span>
            </BButton> -->
          </template>

        </BTable>

        <!-- Tabla -->
        <BTable ref="courseTable" class="position-relative" :items="fetchCourses" :fields="tableColumns" :sort-by.sync="sortBy" :empty-text="$t('No match records found')" :sort-desc.sync="isSortDirDesc" primary-key="id" responsive show-empty v-else>
        <template #cell(course)="data">
            <BLink :to="{ name: 'courses-view', params: { id: data.item.id } }" class="font-weight-bold d-block text-nowrap" > {{ data.item.name }} </BLink>
            <small class="text-muted">{{ data.item.code }} | {{ data.item.section ? data.item.section.name : '' }}</small>
        </template>
        <template #cell(group)="data">
            <BBadge variant="light-info" class="mr-1" v-if="data.item.group"> {{ data.item.group.name }} </BBadge>
            <BBadge variant="info" class="mr-1" v-else> Todas </BBadge>

        </template>
        <template #cell(places)="data">
            <BBadge pill :variant="badgePlaces(data.item.places, data.item.places_taken)">{{  data.item.places - data.item.places_taken }}</BBadge>
        </template>
        <!-- <template #cell(start_date)="data" >
          {{ data.item.start_date ?  format(new Date (data.item.start_date), 'dd-MM-yyyy') : 'Consultar plazos'}}
        </template>

        <template #cell(end_date)="data" >
          {{ data.item.end_date ? format(new Date (data.item.end_date), 'dd-MM-yyyy') : '-' }}
        </template> -->
        <template #cell(dates)="data">
          <small>
              <span><b>Alta: </b>{{ format(new Date (data.item.start_date), 'dd-MM-yyyy') }}</span><br>
              <span><b>Baja: </b>{{ data.item.end_date ? format(new Date (data.item.end_date), 'dd-MM-yyyy') : '(No definida)' }}</span>
          </small>
        </template>

        <template #cell(status)="data">
            <BBadge pill variant="light-success" class="text-capitalize" v-if="data.item.status == 1"> {{$t('Active')}} </BBadge>
            <BBadge pill variant="light-secondary" class="text-capitalize" v-else> {{$t('Inactive')}} </BBadge>
        </template>
        <template #cell(actions)="data">
            <BDropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">

              <template #button-content>
                <FeatherIcon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
              </template>
              <BDropdownItem :to="{ name: 'courses-view', params: { id: data.item.id } }" v-if="ability.can('read', 'course')">
                <FeatherIcon icon="FileTextIcon" />
                <span class="align-middle ml-50">{{$t('Details')}}</span>
              </BDropdownItem>

              <BDropdownItem :to="{ name: 'courses-edit', params: { id: data.item.id } }" v-if="ability.can('write', 'course')">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">{{$t('Edit')}}</span>
              </BDropdownItem>

              <BDropdownItem @click="openRenewalModal(data.item.id, data.item.group_id)">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Generar facturas próxima mensualidad</span>
              </BDropdownItem>

              <BDropdownItem @click="openDateModal(data.item.id, 'students', data.item.name)" v-if="ability.can('read', 'course')">
                <feather-icon icon="ListIcon" />
                <span class="align-middle ml-50">Listado de alumnos</span>
              </BDropdownItem>

              <BDropdownItem @click="openDateModal(data.item.id, 'teachers', data.item.name)" v-if="ability.can('read', 'course')">
                <feather-icon icon="ListIcon" />
                <span class="align-middle ml-50">Listado para profesores</span>
              </BDropdownItem>

              <BDropdownItem @click="deletePopup(data.item.id, 'courses/deleteCourse', '', data.item.code)" v-if="ability.can('delete', 'course')">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">{{$t('Delete')}}</span>
              </BDropdownItem>
            </BDropdown>
          </template>
        </BTable>
        <!-- Paginación -->
        <div class="mx-2 mb-2" v-if="!isTrashedTableActive">
          <BRow>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{$t('Showing')}} {{dataMeta.from}} {{$t('to')}} {{dataMeta.to}} {{$t('of')}} {{dataMeta.of}} {{$t('entries')}}</span>
            </BCol>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <BPagination v-model="currentPage" :total-rows="totalCourses" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text> <feather-icon icon="ChevronLeftIcon" size="18" /> </template>
                <template #next-text> <feather-icon icon="ChevronRightIcon" size="18"/> </template>
              </BPagination>
            </BCol>
          </BRow>
        </div>
      </BCard>

      <!-- Modal de renovaciones -->
      <BModal size="lg" hide-footer ref="renewalModal" cancel-variant="outline-secondary" centered title="Renovar mensualidad manualmente">
            <BForm @submit.prevent="">

              <div>

                <!-- <BCol v-if="most_repeated">
                  <p><b>{{ most_repeated.course_name }}</b></p>
                  <p>Mayoritariamente, se procederá al <b>{{ most_repeated.msg }}</b>.</p>
                  <p><small>*Además se generará una factura a todas aquellas matrículas que tengan una fecha de renovación entre hoy y los próximos 25 días.</small></p>
                </BCol> -->

                <BCol class="pb-1">
                  <BFormGroup label="Importe de la nueva mensualidad (se aplicará a todas las facturas que se generen)" label-for="months_number" >
                    <BFormInput type="number" step="0.01" id="months_number" v-model="renewParams.monthly_payment_amount" required/>
                  </BFormGroup>

                  <small>*El importe que aparece aquí seleccionado es el de una mensualidad completa. Si deseas cobrar una primera/última mensualidad comprueba cuál es su importe e introdúcelo aquí.</small>
                  <div class="pb-1"></div>
                  <small><span class="text-danger">Importante:</span> no sumes al importe de la mensualidad las clases extras ya que todas aquellas que no han sido cobadas se cobrarán automáticamente. </small>
                </BCol>

                <small v-if="groupOptions && showSelectGroup">Se trata de un curso que pertenece a todas las sucursales.</small>
                <VSelectValidated v-if="groupOptions && showSelectGroup" vsName="Sucursal" :vsModel.sync="renewParams.group_id" :vsOptions="groupOptions" vsLabel="name" vsRequired vsRules="required" :vsReduce="group => group.id" />


                <!-- <DatepickerValidated vsName="Selección de la fecha de emisión de las facturas (opcional)" :vsModel.sync="renewParams.invoice_emit_date" /> -->

               
                <BCol class="d-flex justify-content-end mt-2">
                    <BButton variant="danger" class="mr-1" @click="renewalModal.hide()">Cancelar</BButton>
                    <BButton variant="primary" type="submit" @click="generateNextMonthInvoices" id="submitbutton">Añadir</BButton>
                </BCol>
              </div>
                
            </BForm>
      </BModal>

      <!-- Modal de fechas -->
      <BModal ref="datesModal" centered hide-footer >
        <p>Introduzca las fechas: </p>
        <BRow class="mt-2">
              <VSelectValidated vsName="Sucursal" :vsModel.sync="groupModal" :vsOptions="groupOptions" vsLabel="name" vsRequired vsRules="required" :vsReduce="group => group.id" v-if="groupOptions && dateParams.type=='signatures'" />
              <DatepickerValidated vsName="Start date" :vsModel.sync="startDateModal" vsRequired vsRules="required"/>
              <DatepickerValidated vsName="End date" :vsModel.sync="endDateModal" vsRequired vsRules="required" :vsMin="startDateModal"/>
              <BCol>
                <BButton @click="downloadListPDF()" variant="primary">Exportar</BButton>
              </BCol>
        </BRow>
      </BModal>
    </div>
  </template>

  <script>
  import { BCard, BTable, BRow, BCol, BPagination, BDropdown, BDropdownItem, BButton, BFormInput, BLink, BBadge, BModal, BForm, BFormGroup  } from "bootstrap-vue";
  import { onUnmounted, provide, ref } from "@vue/composition-api";
  import CoursesListFilters from "./CoursesListFilters.vue";
  import { getTrashedCourses, restoreCourse } from '@/composables/courseService'
  import courseListQuery from './courseListQuery'
  import courseModule from "../courseModule";
  import ability from '@/libs/acl/ability';
  import popups from "@/hooks/popups";
  import exportUtils from '@/hooks/exportUtils'
  import vSelect from 'vue-select';
  import store from "@/store";
  import { format } from 'date-fns';
  import axios from "@axios";
  import DatepickerValidated from "@/components/forms/DatepickerValidated.vue";
  import VSelectValidated from '@/components/forms/vSelectValidated.vue'
  import TextInputValidated from '@/components/forms/TextInputValidated.vue';

  export default {
    components: { BCard, BTable, BRow, BCol, BPagination, BDropdown, BDropdownItem, BButton, vSelect, BFormInput, BLink, CoursesListFilters, BBadge, BModal, BForm, BFormGroup, DatepickerValidated, VSelectValidated, TextInputValidated },
    setup() {
        const { statusFilter, fetchCourses, tableColumns, perPage, currentPage, totalCourses, dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc, courseTable, refetchData, sectionFilter, groupFilter, taxFilter, sectionOptions, groupOptions, taxOptions, filteredCourses} = courseListQuery()
        const { deletePopup, errorToast, successToast } = popups()
        const { exportData } = exportUtils()
        const user = JSON.parse(localStorage.getItem('userData'));
        const COURSES_MODULE = 'courses'
        const renewalModal = ref(null)
        const datesModal = ref(null)
        const startDateModal = ref(null)
        const trashedCourses = ref([])
        const trashedCourseTable = ref(null)
        const isTrashedTableActive = ref(false)
        const groupModal = ref(null)
        const endDateModal = ref(null)
        const most_repeated = ref(null);
        const courseName = ref(null)
        const dateParams = ref({ 
          course_id: null,
          type: null
        })
        const trashedCoursesColumns = [
          { key: 'course', label: 'Curso' },
          { key: 'actions', label: 'Acciones' }
        ]
        const renewParams = ref({
          monthly_payment_amount: null, 
          course_id: null,
          group_id: null, 
          invoice_emit_date: Date.now()
        })

        const showSelectGroup=ref(false)

        provide('sectionFilter', sectionFilter)
        provide('groupFilter', groupFilter)
        provide('taxFilter', taxFilter)
        provide('statusFilter', statusFilter)
        provide('sections', sectionOptions)
        provide('groups', groupOptions)
        provide('taxes', taxOptions)

        /**
         * Alternar entre tabla de borrados y tabla de activos
         */
        const changeTable = async function() {
          isTrashedTableActive.value = !isTrashedTableActive.value
          if(isTrashedTableActive.value) {
            await fetchTrashedCourses()
          }
        }

        /**
         * Obtener cursos eliminados
         */
         const fetchTrashedCourses = async function() {
            trashedCourses.value = await getTrashedCourses()
        }

        /**
         * Restaurar curso de la papelera
         * @param {integer} course_id id de curso a restaurar
         */
         const restoreCoursefn = async function(course_id) {
            let res = await restoreCourse(course_id)
            if (res.success) {
              successToast('Curso restaurado desde la papelera', 'Restaurado')
            } else {
              errorToast('No se ha podido restaurar el curso de la papelera', 'Error al restaurar')
            }
            fetchTrashedCourses()
            trashedCourseTable.value.refresh()
        }

        /**
         * Abrir modal de renovaciones
         * @param {int} id 
         */
        const openRenewalModal = (id, group_id) =>  {
          renewParams.value.course_id = id
          renewParams.value.monthly_payment_amount = null
          renewParams.value.invoice_emit_date = null
          if (group_id) { showSelectGroup.value=false } else { showSelectGroup.value=true }  

          axios.post('main-expiration-date', {course_id: id}).then((response)=> {
            most_repeated.value = response.data
            renewParams.value.monthly_payment_amount = most_repeated.value.default_amount;
          })
          
          renewalModal.value.show();
        }

        /**
         * Abrir modal de fechas
         */
        const openDateModal = function(id = null, type, nameOfCourse = null) {
          dateParams.value.course_id = id
          dateParams.value.type = type
          courseName.value=nameOfCourse
          datesModal.value.show()
        
        }

        const downloadListPDF = function(){
          if(dateParams.value.type == "students") downloadStudentsListPDF()
          if(dateParams.value.type == "teachers") downloadStudentsTeacherListPDF()
          if ((dateParams.value.type == "signatures")) downloadSignatures()
        }

        /**
         * Generar renovación mensual
         */
        const generateNextMonthInvoices=() => {
          if (!renewParams.value.monthly_payment_amount) {
            return errorToast("Introduce una mensualidad")
          }


          if (!renewParams.value.group_id && showSelectGroup.value==true) {
            return errorToast("Introduce una sucursal")
          }

          document.getElementById('submitbutton').disabled=true;
          axios.post("generate-next-month-invoices", {course_id: renewParams.value.course_id, group_id: renewParams.value.group_id,   monthly_payment: renewParams.value.monthly_payment_amount, invoice_emit_date: renewParams.value.invoice_emit_date}).then((response)=> {
            if (response.data.success) {
              renewalModal.value.hide();
              document.getElementById('submitbutton').disabled=false;
              successToast(response.data.msg)
            } else {

              document.getElementById('submitbutton').disabled=false;
              errorToast(response.data.msg)
            }
          })
        }

        const download = (filetype) => {
          let data = {type: filetype, q: searchQuery.value, group: groupFilter.value, tax: taxFilter.value, section: sectionFilter.value }
          let name = `listado_cursos_filtrados_${new Date(Date.now()).toLocaleDateString('es-ES')}`
          let routeName='download-courses'
            if(exportData(routeName, data, name, filetype)) {} else{errorToast(`No ha sido posible descargar el ${filetype}}`)}  
        }

        /**
         * Descargar listado alumnos matriculados
         */
        const downloadStudentsListPDF = function() {
          if (!startDateModal.value  || !endDateModal.value) {
            errorToast('Introduzca las fechas.')
            return
          }
          let pdfData = {
            id: dateParams.value.course_id,
            start_date: startDateModal.value,
            end_date: endDateModal.value
          }
          axios.post('download-course-students-list', pdfData, { responseType: 'arraybuffer' }).then(response => {
                let blob = new Blob([response.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = courseName.value.replace(/[^a-zA-Z0-9]/g, '_').toLowerCase()+'_firmas'
                link.click()
                datesModal.value.hide()
                successToast('PDF descargado')
          }).catch((error)=> {
            errorToast(error)
          })
        }

        /**
         * Descargar listado de alumnos para profesores
         */
        const downloadStudentsTeacherListPDF = function() {
          if (!startDateModal.value  || !endDateModal.value) {
            errorToast('Introduzca las fechas.')
            return
          }
          let pdfData = {
            id: dateParams.value.course_id,
            start_date: startDateModal.value,
            end_date: endDateModal.value
          }
            axios.post('download-students-teacher-list', pdfData, { responseType: 'arraybuffer' }).then(response => {
                let blob = new Blob([response.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = courseName.value.replace(/[^a-zA-Z0-9]/g, '_').toLowerCase()+'_lista_profesorado'
                link.click()
                datesModal.value.hide()
                successToast('PDF descargado')
            }).catch((error) => {
                errorToast(error)
            })
        }

        const downloadSignatures = function() {
          if (!startDateModal.value  || !endDateModal.value) {
            errorToast('Introduzca las fechas.')
            return
          }

          if (!groupModal.value) {
            errorToast('Selecciona una sucursal.')
            return
          }

          
          let pdfData = {
            start_date: startDateModal.value,
            end_date: endDateModal.value, 
            group: groupModal.value
          }
          let group=groupOptions.value.find(gr => gr.id==groupModal.value)
  
          axios.post('download-signatures-zip', pdfData, { responseType: 'arraybuffer' }).then(response => {
                let blob = new Blob([response.data], { type: 'application/zip' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'firmas_cursos_'+group.name.replace(/[^a-zA-Z0-9 ]/g, '_').toLowerCase()
                link.click()
                datesModal.value.hide()
                successToast('PDF descargado')
          }).catch((error)=> {
            errorToast(error)
          })
        }


        /**
         * Descargar listado de alumnos que han pagado en el mes anterior
         * @param {integer} course_id id de curso
         */
        const downloadPaidListPDF = function(course_id) {
            axios.post('download-paid-list', { course_id: course_id }, { responseType: 'arraybuffer' }).then(response => {
                let blob = new Blob([response.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'listadoPagosCurso'
                link.click()
                successToast('PDF descargado')
            }).catch((error) => {
                errorToast(error)
            })
        }

        /**
         * Color en función del número de plazas
         * @param {integer} total 
         * @param {integer} taken 
         */
        const badgePlaces = function(total, taken) {
          const freePlaces = total - taken
          if(freePlaces <= 0) return 'light-danger'
          if(freePlaces > 0 && freePlaces <= total / 4) return 'light-warning'
          if(freePlaces >= total / 4) return 'light-success'
        }

        if (!store.hasModule(COURSES_MODULE)) store.registerModule(COURSES_MODULE, courseModule)

        onUnmounted(() => {
            if (store.hasModule(COURSES_MODULE)) store.unregisterModule(COURSES_MODULE)
        })

        return {
          downloadStudentsTeacherListPDF,
          downloadStudentsListPDF,
          fetchCourses,
          tableColumns,
          perPage,
          currentPage,
          totalCourses,
          dataMeta,
          perPageOptions,
          searchQuery,
          sortBy,
          isSortDirDesc,
          courseTable,
          refetchData,
          ability,
          deletePopup,
          format,
          badgePlaces,
          downloadPaidListPDF, 
          openRenewalModal, 
          openDateModal,
          generateNextMonthInvoices,
          renewalModal, 
          renewParams, 
          most_repeated,
          datesModal,
          exportData,
          startDateModal,
          endDateModal,
          downloadListPDF,
          groupModal, 
          groupOptions,
          dateParams,
          download,
          changeTable,
          restoreCoursefn,
          user,
          isTrashedTableActive,
          trashedCourses,
          trashedCoursesColumns,
          showSelectGroup
        }
      }
  }
  </script>

  <style lang="scss">
    @import '~@core/scss/vue/libs/vue-select.scss';
  </style>
